export const firebaseConfig = {
    apiKey: "AIzaSyBshrNdNzFjd1dOunUkUBVDsF1dCyoQ68c",
    authDomain: "englishapp-v2.firebaseapp.com",
    databaseURL: "https://englishapp-v2.firebaseio.com",
    projectId: "englishapp-v2",
    storageBucket: "englishapp-v2.firebasestorage.app",
    messagingSenderId: "239032313775",
    appId: "1:239032313775:web:6a9ee94c65d4c909b1315a",
    measurementId: "G-MXVVDBNNN9",
};